import Image from "next/image";

import { translationsContent } from "../../../../localization/translations";
import { useLanguage } from "../../../../store/lang.context";
import imageLoader from "../../../../utils/loader";
import { translate } from "../../../../utils/translate";
import classes from "./diet-portion.module.scss";

export const Colors = {
  GREEN1: "GREEN1",
  GREEN2: "GREEN2",
  GREEN3: "GREEN3",
  GREEN4: "GREEN4",
  GREEN5: "GREEN5",
  GREEN6: "GREEN6",
} as const;

export type ColorsType = typeof Colors[keyof typeof Colors];

const colorClasses = {
  GREEN1: classes.green1,
  GREEN2: classes.green2,
  GREEN3: classes.green3,
  GREEN4: classes.green4,
  GREEN5: classes.green5,
  GREEN6: classes.green6,
};

interface Props {
  number: number;
  titleKey: keyof typeof translationsContent;
  description: keyof typeof translationsContent;
  image1: string;
  image2: string;
  image3?: string;
  color: ColorsType;
  accessory?: string;
  star?: string;
}

const DietPortionComponent = ({
  number,
  titleKey,
  description,
  image1,
  image2,
  image3,
  color,
  accessory,
  star,
}: Props) => {
  const { language } = useLanguage();
  return (
    <div className={classes.dietContainer}>
      <div className={classes.numberStarContainer}>
        <h2 className={`${classes.numberContainer} ${colorClasses[color]}`}>
          {number}
          <span className={classes.starContainer}>{star}</span>
        </h2>
        <p className={`${classes.pointsContainer} ${colorClasses[color]}`}>
          {translate(translationsContent, titleKey, language)}
        </p>
      </div>

      <div className={classes.lineContainer} />
      <div className={classes.dietText}>
        {translate(translationsContent, description, language)}
      </div>
      <div className={classes.imagesContainer}>
        <Image
          src={image1}
          layout="fixed"
          loader={imageLoader}
          height={45}
          width={45}
        />
        <Image
          src={image2}
          layout="fixed"
          loader={imageLoader}
          height={45}
          width={45}
        />
        {image3 && (
          <>
            <div className={classes.accessoryContainer}>{accessory}</div>
            <Image
              src={image3}
              layout="fixed"
              loader={imageLoader}
              height={45}
              width={45}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default DietPortionComponent;
